import APIClient from '@/shared/http/clients/api'

const resourceName = 'REPropostaAnexo'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetAll = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/${id}`, data, config)
const GetAllByRequestId = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/selected/${id}`, data, config)
const GetEnum = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetEnum`, data, config)
const SendImgSolicitacao = (id, type, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/SendImgSolicitacao/${id}/${type}`, data, config)

const AttachmentRequestRepository = {
  GetAll,
  GetAllByRequestId,
  GetEnum,
  SendImgSolicitacao
}

export default AttachmentRequestRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/attachmentRequestRepository.js